/**
 * Cams API
 * Cams
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface AccountStatementOutputDto { 
    name?: string | null;
    accountNumber?: string | null;
    memberId?: string | null;
    startDate?: string;
    endDate?: string;
    status?: string | null;
    productName?: string | null;
    openingBalance?: number;
    closingBalance?: number;
    balance?: number;
    shares?: number;
    principalAmount?: number;
    interestAmount?: number | null;
    outstandingPrincipal?: number | null;
    outstandingInterestAmount?: number | null;
    accountType?: string | null;
}

